export default __webpack_public_path__ + "_/images/app/manual/manual5-9819463932fb30dc4934b394c21572ba58e30401c75a0f7e61365d597a1e9970.png";